export const FONT_SIZE = {
  F10: "10px",
  F12: "12px",
  F13: "13px",
  F14: "14px",
  F16: "16px",
  F18: "18px",
  F20: "20px",
  F24: "24px",
  F28: "28px",
  F32: "32px",
  F36: "36px",
};

export const JUSTIFY_CONTENT = {
  START: "flex-start",
  CENTER: "center",
  END: "flex-end",
  SPACE_BETWEEN: "space-between",
  SPACE_AROUND: "space-around",
};

export const ALIGN_ITEMS = {
  START: "flex-start",
  CENTER: "center",
  END: "flex-end",
  BASELINE: "baseline",
  STRETCH: "stretch",
};

export const FLEX_DIRECTION = {
  ROW: "row",
  COLUMN: "column",
  ROW_REVERSE: "row-reverse",
  COLUMN_REVERSE: "column-reverse",
} as const;

export const TEXT_ALIGN = {
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center",
  JUSTIFY: "justify",
} as const;

export const FONT_WEIGHT = {
  LIGHT: "300",
  REGULAR: "400",
  MEDIUM: "500",
  SEMI_BOLD: "600",
  BOLD: "700",
  EXTRA_BOLD: "800",
};

export const DISPLAY = {
  BLOCK: "block",
  INLINE: "inline",
  INLINE_BLOCK: "inline-block",
  FLEX: "flex",
  GRID: "grid",
  NONE: "none",
};

export const CURSOR = {
  POINTER: "pointer",
  DEFAULT: "default",
  NOT_ALLOWED: "not-allowed",
  TEXT: "text",
  MOVE: "move",
  WAIT: "wait",
  HELP: "help",
  PROGRESS: "progress",
  CROSSHAIR: "crosshair",
  CELL: "cell",
};

export const SPACING = {
  S0: "0px",
  S2: "2px",
  S4: "4px",
  S6: "6px",
  S8: "8px",
  S10: "10px",
  S12: "12px",
  S14: "14px",
  S16: "16px",
  S18: "18px",
  S20: "20px",
  S24: "24px",
  S28: "28px",
  S32: "32px",
  S36: "36px",
  S40: "40px",
  S44: "44px",
  S48: "48px",
  S52: "52px",
  S56: "56px",
  S60: "60px",
  S64: "64px",
  S68: "68px",
};

export const POSITION = {
  RELATIVE: "relative",
  ABSOLUTE: "absolute",
  FIXED: "fixed",
  STICKY: "sticky",
  STATIC: "static",
} as const;
